// @flow

import { ProductIcon } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Placeholder, Text } from '@gandi/ui';

import styles from './Loading.scss';

export function Loading(): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <ProductIcon type="domain" className={styles.icon} />
        <Text weight="semibold" align="center">
          {__('Verification of your domain names')}
        </Text>
        <Placeholder className={styles.bar} />
      </div>
    </div>
  );
}
